export const events = {
  webinarSeries: {
    title: "Webinar Series",
    events: [
      {
        id: 1,
        title: "Smart Grids, Renewable Energy, and Energy Storage Breakthroughs",
        attendeeCount: "",
        registrationCount: "320+",
        date: "10th September 2025",
        time: "6:00 P.M.",
        platform: "Live via Zoom",
        image: "https://media.istockphoto.com/id/1331509308/photo/the-sun-reflects-light-in-the-solar-panel.jpg?s=612x612&w=0&k=20&c=0Dr4PXJMO1y_D55wH8OnZrQWinnxLEFPRu1JmhvmqMc=",
        flyerImage: "../assets/flyers/flyer1.jpg",
        category: "webinar",
        status: "past",
        registerLink: "https://docs.google.com/forms/d/e/1FAIpQLSfay4UkYxy_gLDw0cl9zzoqVO78qk8FqISMF0U2MzXOMLXgPQ/viewform",
        guideline: "",
        description: ""
    },
    {
        id: 2,
        title: "Sustainable Solutions for Smart and Resilient Infrastructure",
        attendeeCount: "",
        registrationCount: "",
        date: "18th September 2025",
        time: "7:00 P.M.",
        platform: "Live via Zoom",
        image: "../assets/flyers/banner2.jpg",
        flyerImage: "../assets/flyers/flyer2.jpg",
        category: "webinar",
        status: "past",
        registerLink: "https://docs.google.com/forms/d/e/1FAIpQLSfay4UkYxy_gLDw0cl9zzoqVO78qk8FqISMF0U2MzXOMLXgPQ/viewform",
        guideline: "",
        description: ""
    },
    {
        id: 3,
        title: "The Power of Presence: Mindfulness Driving Well-Being and Performance .",
        attendeeCount: "",
        registrationCount: "",
        date: "24th September 2025",
        time: "7:00 P.M. - 9:00 P.M.",
        platform: "Live via Zoom",
        image: "../assets/flyers/banner5.webp",
        flyerImage: "../assets/flyers/flyer5.jpg",
        category: "webinar",
        status: "upcoming",
        registerLink: "https://docs.google.com/forms/d/1Lj9ukJXyKmvtJ21mVzDRHAEuSgyKw5dHmcacSqmnAmM/edit#responses",
        guideline: "",
        description: ""
    },
    ]
  },
  competitionSeries: {
    title: "Competitions",
    events: [
      {
        id: 1,
        title: "Introduction to Math Quest Competition",
        attendeeCount: "",
        registrationCount: "",
        date: "31st October 2025",
        time: "All Day",
        platform: "Live via Zoom",
        image: "../assets/flyers/banner3.png",
        flyerImage: "../assets/flyers/flyer3.1.jpg",
        category: "competitions",
        status: "upcoming",
        registerLink: "https://forms.gle/kQdYV4Gy4FBSBfvC9",
        guideline: "https://drive.google.com/file/d/1cAGIWvML0bj6n-sTqf8Iy5tnq81CzPaN/view?usp=drivesdk",
        description: "Math Quest is a Mathematics Quiz Competition organized by the Faculty of Engineering, University of Ruhuna, to celebrate its Silver Jubilee Exhibition. The competition is designed to challenge school A/L Mathematics students on solving, logical reasoning, and teamwork, while providing an engaging and competitive on campus experience."
      },
      {
        id: 2,
        title: "Step into the Spotlight – Pitch Arena Awaits!",
        attendeeCount: "",
        registrationCount: "",
        brief : "Got a spark of genius? Turn it into a flame! This is where creativity meets opportunity — your moment to dream it , pitch it , and own it !",  
        date: "",
        time: "",
        platform: "",
        image: "../assets/flyers/banner4.jpg",
        flyerImage: "../assets/flyers/flyer4.jpg",
        category: "competitions",
        status: "upcoming",
        registerLink: "https://docs.google.com/forms/d/e/1FAIpQLSdf9dA_VISE3CsqGD1d1u3MQFR-QZhlPk_ZZQVilwzGpf-f0Q/viewform",
        guideline: "https://drive.google.com/file/d/1SjUKRkaXt3lxjTxA3WwC99DzTMcsRGpH/view?usp=drive_link",
        description: "Proposal Template: https://docs.google.com/document/d/1QmCyOYJ_DsfGuDPHL1gIJkFls7sefVAm/edit?usp=drive_link&ouid=106346680219335464331&rtpof=true&sd=true"
      }
    ]
  },
  eventSeries: {
    title: "Event Series",
    events: [
      {
        id: 1,
        category: "events",
        title: "TRCSL ICT Volunteer Boot Camp 2025",
        date: "",
        time: "",
        platform: "",
        image: "https://i.imgur.com/zHiicav.png",
        flyerImage: "",
        status: "displayOnly",
        registerLink: "",
        guideline: "",
        description: "",
        attendeeCount: "",
        registrationCount: "",
        brief: "As part of the Silver Jubilee celebrations, the Faculty of Engineering proudly hosts the TRCSL ICT Volunteer Program 2025, in collaboration with the Telecommunications Regulatory Commission of Sri Lanka (TRCSL). The program begins with a two-week residential boot camp (August 11–22, 2025) at the Faculty, where 50 undergraduate volunteers are trained in both technical and teaching skills. Following the boot camp, these volunteers will conduct ICT workshops in rural schools (September–October 2025), empowering students with digital knowledge while gaining real-world teaching and leadership experience. This initiative not only enhances digital literacy in underserved communities but also strengthens the role of youth in bridging the digital divide."
      },
      {
        id: 2,
        category: "events",
        title: "IEEE Starlink Installation Project",
        date: "",
        time: "",
        platform: "",
        image: "https://imgur.com/9wVL9Z6.jpeg",
        flyerImage: "",
        status: "displayOnly",
        registerLink: "",
        guideline: "",
        description: "",
        attendeeCount: "",
        registrationCount: "",
        brief: "As part of the 25th Anniversary celebrations of the Faculty of Engineering, University of Ruhuna, a Smart Classroom and Starlink connection were donated to Dellawa Maha Vidyalaya under the Internet for All initiative on 6th August 2025. This remarkable project was made possible through a highly competitive global grant from IEEE ComSoc and IEEE Tech4Good (T4G), awarded to our project team — Dr. Chatura Seneviratne (Team Lead), Dr. Geeth Priyankara, and Dr. Thilina Weerasinghe — with the support of dedicated IEEE ComSoc student volunteers who actively contributed to organizing the event and engaging with the school community. This milestone stands as a testament to our continued commitment to bridging digital divides, empowering young learners, and creating equitable opportunities through technology. More than an event, it was a meaningful step toward transforming education through connectivity and innovation — shaping brighter futures for generations to come."
      }
    ]
  }
};

// Utility functions to filter events by status
export const getEventsByStatus = (status) => {
  const filteredEvents = {};
  
  Object.entries(events).forEach(([eventType, eventData]) => {
    const filteredEventData = {
      ...eventData,
      events: eventData.events.filter(event => event.status === status)
    };
    
    if (filteredEventData.events.length > 0) {
      filteredEvents[eventType] = filteredEventData;
    }
  });
  
  return filteredEvents;
};

export const getUpcomingEvents = () => {
  const filteredEvents = {};
  
  Object.entries(events).forEach(([eventType, eventData]) => {
    const filteredEventData = {
      ...eventData,
      events: eventData.events.filter(event => 
        event.status === 'upcoming' || event.status === 'happening-now'
      )
    };
    
    if (filteredEventData.events.length > 0) {
      filteredEvents[eventType] = filteredEventData;
    }
  });
  
  return filteredEvents;
};
export const getPastEvents = () => getEventsByStatus('past');
export const getExpiredEvents = () => getEventsByStatus('expired');

// Events with status 'happening-now' are excluded from display by design
export const getDisplayableEvents = () => {
  const filteredEvents = {};
  
  Object.entries(events).forEach(([eventType, eventData]) => {
    const filteredEventData = {
      ...eventData,
      events: eventData.events.filter(event => event.status !== 'happening-now')
    };
    
    if (filteredEventData.events.length > 0) {
      filteredEvents[eventType] = filteredEventData;
    }
  });
  
  return filteredEvents;
};